/* eslint-disable max-len */
import React from 'react';
import { Svg, Path } from '@react-pdf/renderer';

const Email = () => (
  <Svg height='24' viewBox='0 0 24 24' width='24'>
    <Path
      fill='#525252'
      d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57V12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57V12c0-5.52-4.48-10-10-10zm0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z'
    />
    <Path d='M0 0h24v24H0z' fill='none' />
  </Svg>
);

const Mehrcollig = () => (
  <Svg width='24' height='24' viewBox='0 0 24 24'>
    <Path
      d='M19.4384 0.813711C19.6793 0.572823 20.0061 0.4375 20.3468 0.4375C20.6875 0.4375 21.0142 0.572823 21.2552 0.813711L23.1863 2.74496C23.4272 2.98592 23.5625 3.31269 23.5625 3.65341C23.5625 3.99413 23.4272 4.3209 23.1863 4.56186L21.2552 6.49311C21.0142 6.734 20.6875 6.86932 20.3468 6.86932C20.0061 6.86932 19.6793 6.734 19.4384 6.49311L17.506 4.56186C17.2651 4.3209 17.1298 3.99413 17.1298 3.65341C17.1298 3.31269 17.2651 2.98592 17.506 2.74496L19.4371 0.813711H19.4384ZM6.21213 21H8.13941V15.8603H3V17.7877C3 18.6396 3.33842 19.4567 3.94081 20.0591C4.5432 20.6616 5.36022 21 6.21213 21ZM8.13941 9.43561V14.5753H3V9.43561H8.13941ZM14.5637 14.5753H9.42426V9.43561H14.5637V14.5753ZM9.42426 15.8603H14.5637V21H9.42426V15.8603ZM15.8485 9.43561V14.5753H20.9879V9.43561H15.8485ZM15.8485 15.8603H20.9879V17.7877C20.9879 18.6396 20.6495 19.4567 20.0471 20.0591C19.4447 20.6616 18.6277 21 17.7758 21H15.8485V15.8603ZM3 8.15068H8.13941V3.01095H6.21213C5.36022 3.01095 4.5432 3.34939 3.94081 3.95182C3.33842 4.55424 3 5.37131 3 6.22328V8.15068ZM9.42426 8.15068V3.01095H14.5637V8.15068H9.42426Z'
      fill='#525252'
    />
  </Svg>
);

const Valuable = () => (
  <Svg height='24' viewBox='0 0 24 24' width='24'>
    <Path
      fill='#525252'
      d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z'
    />
    <Path d='M0 0h24v24H0z' fill='none' />
  </Svg>
);
const Luggage = () => (
  <Svg width='24' height='24' viewBox='0 0 24 24'>
    <Path
      d='M20 6H16V4C16 2.89 15.11 2 14 2H10C8.89 2 8 2.89 8 4V6H4C2.89 6 2.01 6.89 2.01 8L2 19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM14 6H10V4H14V6Z'
      fill='#525252'
    />
  </Svg>
);
const IdentService = () => (
  <Svg width='24' height='24' viewBox='0 0 24 24'>
    <Path
      d='M3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3H5C3.89 3 3 3.9 3 5ZM15 9C15 10.66 13.66 12 12 12C10.34 12 9 10.66 9 9C9 7.34 10.34 6 12 6C13.66 6 15 7.34 15 9ZM6 17C6 15 10 13.9 12 13.9C14 13.9 18 15 18 17V18H6V17Z'
      fill='#525252'
    />
  </Svg>
);
const Nachnahme = () => (
  <Svg width='24' height='24' viewBox='0 0 24 24'>
    <Path
      d='M15 18.5C12.49 18.5 10.32 17.08 9.24 15H15V13H8.58C8.53 12.67 8.5 12.34 8.5 12C8.5 11.66 8.53 11.33 8.58 11H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5C16.61 5.5 18.09 6.09 19.23 7.07L21 5.3C19.41 3.87 17.3 3 15 3C11.08 3 7.76 5.51 6.52 9H3V11H6.06C6.02 11.33 6 11.66 6 12C6 12.34 6.02 12.67 6.06 13H3V15H6.52C7.76 18.49 11.08 21 15 21C17.31 21 19.41 20.13 21 18.7L19.22 16.93C18.09 17.91 16.62 18.5 15 18.5Z'
      fill='#525252'
    />
  </Svg>
);
const VerbotNachbarschaftsAbgabe = () => (
  <Svg width='24' height='24' viewBox='0 0 24 24'>
    <Path
      d='M12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22ZM12 4C7.58 4 4 7.58 4 12C4 13.85 4.63 15.55 5.69 16.9L16.9 5.69C15.55 4.63 13.85 4 12 4ZM18.31 7.1L7.1 18.31C8.45 19.37 10.15 20 12 20C16.42 20 20 16.42 20 12C20 10.15 19.37 8.45 18.31 7.1Z'
      fill='#525252'
    />
  </Svg>
);
const WunschTag = () => (
  <Svg width='24' height='24' viewBox='0 0 24 24'>
    <Path
      d='M17 12H12V17H17V12ZM16 1V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3H18V1H16ZM19 19H5V8H19V19Z'
      fill='#525252'
    />
  </Svg>
);
const WunschzeitFenster = () => (
  <Svg width='24' height='24' viewBox='0 0 24 24'>
    <Path
      d='M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM16.2 16.2L11 13V7H12.5V12.2L17 14.9L16.2 16.2Z'
      fill='#525252'
    />
  </Svg>
);
const Eil = () => (
  <Svg width='24' height='24' viewBox='0 -3 19 24'>
    <Path
      d='M16.213 2.76507C14.4634 1.02587 12.1063 0.0347123 9.63955 0.000894554C7.17279 -0.0329232 4.78943 0.893246 2.99276 2.58382C1.19609 4.2744 0.126756 6.59706 0.0105627 9.06132C-0.105631 11.5256 0.740413 13.9385 2.37004 15.7907L2.37717 15.7986C2.39024 15.8125 2.40253 15.8267 2.41679 15.8402C2.44611 15.8735 2.47939 15.9111 2.51862 15.9504C2.67245 16.1139 2.85838 16.2439 3.06476 16.3322C3.27114 16.4205 3.49354 16.4653 3.71803 16.4638C3.94252 16.4622 4.16427 16.4143 4.36941 16.3231C4.57454 16.2319 4.75864 16.0993 4.91018 15.9337C5.49327 15.3 6.2015 14.7941 6.99009 14.4481C7.77867 14.1021 8.63047 13.9234 9.49163 13.9234C10.3528 13.9234 11.2046 14.1021 11.9932 14.4481C12.7818 14.7941 13.49 15.3 14.0731 15.9337C14.2257 16.1002 14.4113 16.2332 14.6181 16.3243C14.8248 16.4153 15.0482 16.4624 15.2741 16.4627C15.5 16.4629 15.7235 16.4162 15.9304 16.3255C16.1373 16.2349 16.3231 16.1023 16.4761 15.9361L16.6033 15.7974L16.6104 15.7895C18.2161 13.9763 19.0692 11.6187 18.9956 9.19791C18.922 6.7771 17.9271 4.47568 16.2142 2.76348L16.213 2.76507ZM8.8553 3.15138C8.8553 2.98324 8.9221 2.822 9.04098 2.70311C9.15987 2.58422 9.32112 2.51743 9.48925 2.51743C9.65738 2.51743 9.81863 2.58422 9.93752 2.70311C10.0564 2.822 10.1232 2.98324 10.1232 3.15138V4.41927C10.1232 4.5874 10.0564 4.74865 9.93752 4.86754C9.81863 4.98642 9.65738 5.05322 9.48925 5.05322C9.32112 5.05322 9.15987 4.98642 9.04098 4.86754C8.9221 4.74865 8.8553 4.5874 8.8553 4.41927V3.15138ZM4.41768 10.1248H3.14979C2.98166 10.1248 2.82041 10.058 2.70152 9.93911C2.58264 9.82022 2.51584 9.65897 2.51584 9.49084C2.51584 9.3227 2.58264 9.16146 2.70152 9.04257C2.82041 8.92368 2.98166 8.85689 3.14979 8.85689H4.41768C4.58582 8.85689 4.74706 8.92368 4.86595 9.04257C4.98484 9.16146 5.05163 9.3227 5.05163 9.49084C5.05163 9.65897 4.98484 9.82022 4.86595 9.93911C4.74706 10.058 4.58582 10.1248 4.41768 10.1248V10.1248ZM6.35122 6.3528C6.23234 6.4716 6.07116 6.53834 5.9031 6.53834C5.73504 6.53834 5.57385 6.4716 5.45498 6.3528L4.55834 5.45656C4.43944 5.33766 4.37264 5.1764 4.37264 5.00825C4.37264 4.84009 4.43944 4.67883 4.55834 4.55993C4.67724 4.44102 4.83851 4.37423 5.00666 4.37423C5.17481 4.37423 5.33607 4.44102 5.45498 4.55993L6.35122 5.45656C6.47002 5.57544 6.53675 5.73662 6.53675 5.90468C6.53675 6.07275 6.47002 6.23393 6.35122 6.3528V6.3528ZM12.2667 7.26806L10.3847 10.2595C10.3077 10.3662 10.2141 10.4599 10.1073 10.5368C9.84973 10.7166 9.53164 10.7874 9.2221 10.7341C8.91255 10.6807 8.63655 10.5074 8.45397 10.2518C8.2714 9.99623 8.197 9.67894 8.24692 9.36883C8.29683 9.05871 8.46704 8.78079 8.72059 8.59539L11.712 6.71336C11.78 6.66596 11.8609 6.64055 11.9438 6.64055C12.0267 6.64055 12.1076 6.66596 12.1756 6.71336C12.261 6.77502 12.3185 6.86797 12.3356 6.97191C12.3527 7.07585 12.3279 7.18232 12.2667 7.26806V7.26806ZM13.5235 6.3528C13.4037 6.46667 13.2441 6.52922 13.0788 6.5271C12.9135 6.52499 12.7555 6.45838 12.6386 6.34148C12.5217 6.22457 12.4551 6.06663 12.453 5.90132C12.4509 5.73601 12.5134 5.57642 12.6273 5.45656L13.5235 4.55993C13.6424 4.44102 13.8037 4.37423 13.9718 4.37423C14.14 4.37423 14.3013 4.44102 14.4202 4.55993C14.5391 4.67883 14.6059 4.84009 14.6059 5.00825C14.6059 5.1764 14.5391 5.33766 14.4202 5.45656L13.5235 6.3528ZM15.8287 10.1248H14.5608C14.3927 10.1248 14.2314 10.058 14.1126 9.93911C13.9937 9.82022 13.9269 9.65897 13.9269 9.49084C13.9269 9.3227 13.9937 9.16146 14.1126 9.04257C14.2314 8.92368 14.3927 8.85689 14.5608 8.85689H15.8287C15.9968 8.85689 16.1581 8.92368 16.277 9.04257C16.3959 9.16146 16.4627 9.3227 16.4627 9.49084C16.4627 9.65897 16.3959 9.82022 16.277 9.93911C16.1581 10.058 15.9968 10.1248 15.8287 10.1248Z'
      fill='#525252'
    />
  </Svg>
);
const BNK = () => (
  <Svg width='24' height='24' viewBox='0 0 24 24'>
    <Path
      d='M19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3ZM14 17H7V15H14V17ZM17 13H7V11H17V13ZM17 9H7V7H17V9Z'
      fill='#525252'
    />
  </Svg>
);
export const Bulky = () => (
  <Svg width='11' height='15' viewBox='0 0 11 15'>
    <Path
      d='M5.85547 8.85742H2.20312L2.18359 6.72852H5.20117C5.73503 6.72852 6.16797 6.66341 6.5 6.5332C6.83854 6.40299 7.08594 6.21419 7.24219 5.9668C7.39844 5.71289 7.47656 5.40039 7.47656 5.0293C7.47656 4.60612 7.39844 4.26432 7.24219 4.00391C7.08594 3.74349 6.83854 3.55469 6.5 3.4375C6.16797 3.3138 5.73828 3.25195 5.21094 3.25195H3.35547V15H0.171875V0.78125H5.21094C6.0638 0.78125 6.82552 0.859375 7.49609 1.01562C8.16667 1.17188 8.73633 1.41276 9.20508 1.73828C9.68034 2.0638 10.0417 2.4707 10.2891 2.95898C10.5365 3.44727 10.6602 4.02344 10.6602 4.6875C10.6602 5.26693 10.5299 5.80729 10.2695 6.30859C10.0156 6.8099 9.60547 7.2168 9.03906 7.5293C8.47266 7.8418 7.71419 8.01107 6.76367 8.03711L5.85547 8.85742ZM5.72852 15H1.39258L2.54492 12.5391H5.72852C6.2168 12.5391 6.61393 12.4609 6.91992 12.3047C7.22591 12.1484 7.45052 11.9368 7.59375 11.6699C7.73698 11.403 7.80859 11.1035 7.80859 10.7715C7.80859 10.3809 7.74023 10.0423 7.60352 9.75586C7.47331 9.4694 7.26497 9.24805 6.97852 9.0918C6.69857 8.93555 6.32422 8.85742 5.85547 8.85742H3.00391L3.02344 6.72852H6.50977L7.25195 7.56836C8.1569 7.54883 8.87956 7.69531 9.41992 8.00781C9.9668 8.3138 10.3607 8.71745 10.6016 9.21875C10.8424 9.72005 10.9629 10.2507 10.9629 10.8105C10.9629 11.735 10.7643 12.5098 10.3672 13.1348C9.97005 13.7533 9.38086 14.2188 8.59961 14.5312C7.82487 14.8438 6.86784 15 5.72852 15Z'
      fill='#525252'
    />
  </Svg>
);
export const getPdfIconByName = (name: string) => {
  switch (name.toLowerCase()) {
    case 'email':
      return <Email key='email' />;
    case 'colli':
      return <Mehrcollig key='mehrcollig' />;
    case 'valuable':
      return <Valuable key='valuable' />;
    case 'luggage':
      return <Luggage key='luggage' />;
    case 'identservice':
      return <IdentService key='identservice' />;
    case 'nachnahme':
      return <Nachnahme key='nachnahme' />;
    case 'verbotnachbarschaftsabgabe':
      return <VerbotNachbarschaftsAbgabe key='verbot-nachbarschafts-abgabe' />;
    case 'wunschtag':
      return <WunschTag key='wunschtag' />;
    case 'wunschzeitfenster':
      return <WunschzeitFenster key='wunschzeit-fenster' />;
    case 'eilservice':
      return <Eil key='eil' />;
    case 'number':
      return <BNK key='bnk' />;
    case 'bulky':
      return <Bulky key='bulky' />;
    default:
      return null;
  }
};

export default {
  Email,
  Mehrcollig,
  Valuable,
  Luggage,
  IdentService,
  Nachnahme,
  VerbotNachbarschaftsAbgabe,
  WunschTag,
  WunschzeitFenster,
  Eil,
  BNK,
  Bulky,
};
